import { gql } from 'apollo-angular';

export const SendMailMutation = gql`
  mutation SendMailMutation($input: SendMailToReconceptInput!) {
    sendMailToReconcept(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
